import { render } from "./popupTopic.vue?vue&type=template&id=61333353"
import script from "./popupTopic.vue?vue&type=script&lang=js"
export * from "./popupTopic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__